const EventEmitter = require('events');

class Dispatcher extends EventEmitter {}

const dispatcher = new Dispatcher();
dispatcher.setMaxListeners(1000)

window.dispatcher = dispatcher

export default dispatcher



// WEBPACK FOOTER //
// ./src/dispatcher.js